import React, { Component } from 'react'

class IconRight extends Component {
  render() {
    return (
      <div>
        <div className="rounded-icons rounded" />
        <svg className="icon-spark icon-right" width="44" height="47">
          <path
            fill="#FFE269"
            d="M28.71 1.103l1.691 14.11c.05.41.292.769.649.96l12.292 6.571c.9.48.87 1.81-.048 2.249l-12.563 6.01a1.25 1.25 0 0 0-.69.928l-2.294 14.021c-.168 1.025-1.41 1.408-2.1.648L16.19 36.203a1.205 1.205 0 0 0-1.074-.385L1.406 37.912c-1.003.154-1.741-.939-1.25-1.848l6.72-12.435c.194-.361.204-.797.024-1.167L.722 9.736c-.452-.931.333-1.989 1.328-1.79l13.607 2.71c.396.08.803-.046 1.09-.336L26.64.361c.723-.729 1.947-.29 2.07.742z"
            opacity=".362"
          />
        </svg>
        <svg className="icon-spark icon-top" width="40" height="41">
          <path
            fill="#FFE269"
            d="M16.888.32l8.507 9.439a.97.97 0 0 0 .842.311L38.91 8.48c.795-.1 1.36.746.956 1.431l-6.434 10.93a.949.949 0 0 0-.039.89l5.444 11.446c.34.717-.297 1.511-1.08 1.343l-12.483-2.683a.973.973 0 0 0-.867.238l-9.309 8.664c-.583.543-1.542.188-1.623-.601L12.194 27.55a.956.956 0 0 0-.496-.743L.5 20.716a.953.953 0 0 1 .076-1.715l11.692-5.097a.959.959 0 0 0 .56-.696L15.218.778c.15-.778 1.136-1.05 1.67-.458z"
          />
        </svg>
        <svg className="icon-spark icon-bottom" width="25" height="24">
          <path
            fill="#FFE269"
            d="M6.72.126l6.182 3.779a.852.852 0 0 0 .781.055l6.666-2.872c.639-.275 1.321.29 1.154.957L19.764 9a.819.819 0 0 0 .188.749l4.834 5.354c.463.513.128 1.327-.567 1.377l-7.257.52a.842.842 0 0 0-.665.408l-3.678 6.181c-.353.593-1.242.53-1.505-.106L8.368 16.85a.839.839 0 0 0-.599-.497L.662 14.819a.824.824 0 0 1-.363-1.442l5.56-4.622a.822.822 0 0 0 .295-.714L5.439.91C5.371.228 6.128-.236 6.72.126z"
          />
        </svg>
        <div className="icon-centered-holder ">
          <div className="icon-centered rounded success">
            <svg width="47" height="44">
              <path
                fill="#fff"
                d="M2.002 28.54c-1.569-1.569-1.373-4.119.393-5.492 1.569-1.57 4.12-1.373 5.492.392l8.828 10.2L41.824 2.45c3.138-3.923 7.061-1.372 3.923 2.747L20.246 42.272l-.589.588c-1.765 1.57-4.12 1.374-5.689-.392L2.002 28.54z"
              />
            </svg>
          </div>
        </div>
      </div>
    )
  }
}

export default IconRight



// WEBPACK FOOTER //
// ./src/svg/icon-right.js